<template>
  <div class="limit-modal flex-y-center flex-col">
    <iconpark-icon name="close" class="icon-close" @click="handleClose"> </iconpark-icon>
    <iconpark-icon name="Popupiconwarn" class="icon-warning mb-[10px]"></iconpark-icon>
    <div class="title">{{ $t('wu-fa-jia-gou-yan-bi') }}</div>
    <div class="sub">
      {{
        $t(
          'nin-yi-da-dao-tuan-dui-ru-men-ban-zhang-hao-jia-gou-shang-xian-qing-lian-xi-wo-men-sheng-ji-qi-ye-ban-zhang-hao',
        )
      }}
    </div>
    <div class="operation mt-[40px] flex gap-[16px]">
      <a-button @click="handleClose">{{ $t('qu-xiao') }}</a-button>
      <a-button type="primary" @click="handleContact"> {{ $t('lian-xi-wo-men') }} </a-button>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { PositionCode, showDynamicContact } from '@rendora/common/features/contact';
import { ModalFactory } from '@rendora/common/features/modals/factory';
import { limitModalSymbol } from './symbols';

const modalInstance = ModalFactory.getInstance(limitModalSymbol);

const handleClose = () => {
  modalInstance?.close();
};

const handleContact = () => {
  modalInstance?.close();
  showDynamicContact(PositionCode['企业版言币不足']); // @xi18n-ignore
};
</script>

<style lang="scss" scoped>
.list {
  width: 300px;
  height: 90px;
  background: var(--x-back-2);
  border-radius: var(--x-radius-medium);
  padding: 18px 20px;
  margin-top: 20px;
  > .t {
    font-weight: var(--x-weight-medium);
    font-size: 14px;
    color: var(--x-text-1);
    line-height: 20px;
  }
}
.title {
  font-size: 16px;
  color: var(--x-text-1);
  line-height: 22px;
  margin-bottom: 10px;
  font-weight: 600;
}
.sub {
  width: 282px;
  text-align: center;
  font-size: 13px;
  line-height: 20px;
  color: var(--x-text-1-70);
}
.icon-close {
  position: absolute;
  opacity: 0.6;
  font-size: 16px;
  right: 16px;
  top: 16px;
}
.icon-warning {
  font-size: 48px;
}
.limit-modal {
  display: flex;
  justify-content: center;
  width: 420px;
  height: 380px;
  background: #ffffff;
  border-radius: var(--x-radius-medium);
}
</style>
